<template>
  <el-container>
    <img class="banner" src="../assets/img/news.jpg" />
    <div class="bg-box">
      <el-aside width="315px">
        <left-menu :menuList="menuList" @activeMeun="activeMeun" :activeMenuIndex="activeMenuIndex"></left-menu>
      </el-aside>
      <div class="right-text">
        <div class="title1">{{activeText}}</div>
        <div class="title2">{{activeTextEng}}</div>
        <el-divider></el-divider>
        <span v-show="activeText == '福保动态'" class="list-bg" >
          <span v-for="(item , index) in newsList"
          :key="index"
           @click="toDetails('福保动态',index)"
           class="news-box"
           >
            <div class="time">
                <span>{{(item.time).substr(8) }}</span>
                {{(item.time).substr(5,3) }}
                {{(item.time).substr(0,4) }}
                </div>
            <span class="red-line"></span>
            <img :src="item.img" />
            <div class="text-box">
              <p>{{item.title}}</p>
              <span>{{item.text}}</span>
            </div>
          </span>
        </span>
        <span v-show="activeText == '行业动态'" class="list-bg">
            <span v-for="(item , index) in industryNewsList"
             :key="index"
             @click="toDetails('行业动态',index)"
              class="news-box">
                <div class="time">
                    <span>{{(item.time).substr(8) }}</span>
                    {{(item.time).substr(5,3) }}
                    {{(item.time).substr(0,4) }}
                    </div>
                <span class="red-line"></span>
                <img :src="item.img" />
                <div class="text-box">
                <p>{{item.title}}</p>
                <span>{{item.text}}</span>
                </div>
            </span>
        </span>
        <div class="is-bg">
         <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          layout="  prev, pager, next, jumper,total"
          :total="6">
        </el-pagination>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import leftMenu from "@/components/leftMenu";
export default {
  name: "business",
  components: {
    leftMenu
  },
  data() {
    return {
      activeMenuIndex:0,
      currentPage4: 1,
      menuList: ["福保动态", "行业动态"],
      activeText: "",
      newsList: [
        {
          time: "2021年10月18",
          title: "辽宁福保保险经纪有限公司城阳分公司成立",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "辽宁福保保险经纪有限公司城阳公司于2021年10月18日通过当地监管部门审批，并于同期正式开业。辽宁福保保险经纪有限公司城阳分公司是福保保险经纪公司开设的第18家机构，也是第7家三级机构"
        },
        {
          time: "2021年10月12",
          title: "辽宁福保保险经纪有限公司重庆分公司成立",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "辽宁福保保险经纪有限公司重庆公司报备于2021年10月12日通过当地监管部门审批，并于同期正式开业。辽宁福保保险经纪有限公司重庆分公司是福保保险经纪公司开设的第17家机构，也是第11家二级机构。"
        },
        {
          time: "2021年08月10",
          title: "辽宁福保保险经纪有限公司陕西汉中分公司成立",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "辽宁福保保险经纪有限公司陕西汉中分公司报备于2021年8月10日通过当地监管部门审批，并于同期正式开业。辽宁福保保险经纪有限公司陕西汉中分公司是继渭南分公司、榆林分公司之后，陕西分公司开设的第三家地市级分公司，也是福保保险经纪公司开设的第16家机构，第6家三级机构。"
        },
        {
          time: "2020年12月10",
          title: "辽宁福保保险经纪有限公司履职回避豁免公示",
          img: require('../assets/img/news_img6.jpg'),
          text:
            "根据《中国银保监会关于银行保险机构员工履职回避工作的指导意见》（银保监发[2019]50号）等有关制度规定，现将任职人员情况公示。"
        },
        {
          time: "2020年10月28",
          title: "辽宁福保保险经纪有限公司山西分支机构设立事项公告",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "近期，我公司分支机构发生如下事项，特此公告。"
        },
        {
          time: "2020年10月28",
          title: "辽宁福保保险经纪有限公司陕西分支机构设立事项公告",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "近期，我公司分支机构发生如下事项，特此公告。"
        },
        {
          time: "2020年10月28",
          title: "辽宁福保保险经纪有限公司吉林分支机构设立事项公告",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "近期，我公司分支机构发生如下事项，特此公告。"
        },
        {
          time: "2020年10月28",
          title: "辽宁福保保险经纪有限公司深圳分支机构设立事项公告",
          img: require('../assets/img/news_img5.jpg'),
          text:
            "近期，我公司分支机构发生如下事项，特此公告。"
        },
        {
          time: "2020年03月31",
          title: "福保保险经纪增资情况说明",
          img: require('../assets/img/news_img1.jpg'),
          text:
            "2020年3月31日，辽宁福保保险经纪有限公司注册资本金从1000万元增资至5000万元。经营区域不限于工商注册登记地所在省、自治区、直辖市、计划单列市，成为全国性保险经纪公司。"
        }
      ],
       industryNewsList: [
         {
          time: "2021年12月24",
          title: "不得拒保！银保监会发文要求切实做好营运车辆承保工作",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "近段时间以来，多地区出现部分险企拒保营运车辆交强险的新闻，立刻引起了行业的高度关注。针对此事，近期，银保监会财险部已向各财险公司下发《关于切实做好营运车辆保险承保工作的通知》（以下简称《通知》），要求各财险公司积极主动为营运车辆提供保险服务，全面排查整改营运车辆保险承保限制政策，坚决杜绝以任何形式拒保或拖延承保交强险行为。"
        },
          {
          time: "2021年12月18",
          title: "重疾险突围之路：高倍“治病存钱”定位，重构销售逻辑（二）",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "导语：上一篇文章对于重疾险当下的发展困境，造成其困境的因素进行了深入分析，本文着重对于重疾险可能的突围路径进行详细的解析。"
        },
          {
          time: "2021年12月10",
          title: "重疾险突围之路：高倍“治病存钱”定位，重构销售逻辑（一）",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "导语：文章对于重疾险当下的发展困境，造成其困境的因素进行了深入分析，对于重疾险可能的突围路径也进行了详细的解析。文章指出，功能虽全但保障效率低的特点使重疾险看起来更像“奢侈品”，不利于吸引新一代保险消费者，且代理人基于既往重疾险形态向客户传达的“治病存钱”功能在当下已经被替代。"
        },
         {
          time: "2021年12月3",
          title: "董责险市场需求激增 更有上市公司想靠该险种挽留独董！",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "KM药业一审宣判结果带火了董责险，独董们拿着几十万年薪却承担上亿的赔偿责任，让外界深刻感受到高管面临的职业风险。案件判决结果一出。国内某知名财险公司在5个工作日收到超过50家上市公司的正式采购咨询，也有上市公司希望通过董责险吸引独董任职，规避风险"
        },
         {
          time: "2021年11月11",
          title: "险企纷纷布局宠物险，蓝海市场隐藏的“暗礁”该如何躲过？",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "“带‘主子’去一次医院，半个月工资就没了。”这是不少“铲屎官”的切身感受。越来越多的养宠人把宠物当成家庭成员来看，由于这类特殊的家庭成员没有“医保”，通过购买商业保险降低宠物医疗支出也成了养宠人的必然需求。"
        },
         {
          time: "2021年09月24",
          title: "中国银保监会发布新修订的《再保险业务管理规定》",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "为规范再保险业务经营，有效防范化解风险，推动再保险市场高质量发展，近日，中国银保监会发布了新修订的《再保险业务管理规定》（以下简称《规定》）。"
        },
        {
          time: "2021年09月24",
          title: "首部强制性安责险标准出台 保险责任亟待落实",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "2019年3月21日，江苏省盐城市响水县陈家港镇的江苏天嘉宜化工有限公司化学储罐发生爆炸，造成78人死亡；4月25日，河北省衡水市翡翠华庭建筑工地发生重大事故，造成11人死亡、2人受伤……"
        },
        {
          time: "2021年09月17",
          title: "保险行业直播带货时，投保人应该警惕哪些信息",
          img: require('../assets/img/news_img4.jpg'),
          text:
            "核心提示：现在这个时代环境下，直播带货俨然已经成为一种风潮。各行各业都开始用直播带货的方式来运作，保险行业也开始“尝鲜”。就像国务院发展研究中心的朱俊生说的，“在直播带货的大环境下，保险行业也得做一些尝试，探索保险销售方式的多元化。"
        },
        {
          time: "2020年06月16",
          title: "中国保险经纪行业市场规模与预测",
          img: require('../assets/img/news_img3.jpg'),
          text:
            "据立木信息咨询发布的《中国保险经纪市场调查与发展前景研究报告（2018版）（2018版）》显示：保险经纪市场是连接保险公司和广大投保人的桥梁和纽带，是保险业服务社会的窗口，保险业越发达，保险经纪越重要"
        },
        {
          time: "2020年03月26",
          title: "保险保费持续增长，上市公司纷纷布局保险经纪行业",
          img: require('../assets/img/news_img2.jpg'),
          text:
            "截至2018年底，保险中介渠道实现保费收入3.37万亿元，占全国总保费收入的87.4%。分渠道来看，保险专业中介渠道实现保费收入0.49万亿元，保险兼业渠道实现保费收入1.07万亿元、营销员渠道实现保费收入"
        },
      ],
    };
  },
   //监听路由不变参数改变
  beforeRouteUpdate(to, from, next) {
        if(to.query.id){
            this.activeText=to.query.id;
            if(to.query.id =="福保动态"){
                this.activeMenuIndex= 0;
            }else if(to.query.id =="行业动态"){
                this.activeMenuIndex =1;
            }
            window.scrollTo(0,0);
        }
        next();
    },
    created(){
        this.$nextTick(()=>{
            if(this.$route.query.id){
                this.activeMeun(this.$route.query.id)
                switch (this.$route.query.id) {
                    case '福保动态':
                        this.activeMenuIndex = 0
                        break;
                     case '行业动态':
                        this.activeMenuIndex = 1
                        break;

                    default:
                        break;
                }
                window.scrollTo(0,0);
            }
        })
    },
  computed: {
    activeTextEng() {
      switch (this.activeText) {
        case "福保动态":
          return "FUBAO DYNAMIC";
          break;
        case "行业动态":
          return "INDUSTRY DYNAMICS";
          break;

        default:
          break;
      }
    }
  },
  methods: {
    activeMeun(data) {
      this.activeText = data;
    },
    toDetails(Str,index){
        switch (Str) {
            case '福保动态':
                this.$router.push({
                    path:'newsDetail',
                    query:  {
                        activeMenu:Str,
                        index:index
                        }
                })
                break;
            case '行业动态':
                this.$router.push({
                    path:'newsDetail',
                    query: {
                        activeMenu:Str,
                        index:index
                        }
                })
                break;

            default:
                break;
        }


    },
     handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-aside {
  overflow: hidden;
}
/deep/ .el-divider {
  background-color: $font-color-gary2;
  margin-bottom: 0px;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: $green !important;
    color:#FFF
    }
/deep/ .el-pagination.is-background .el-pager li:hover{
    color: $green  !important;
    }
.el-container {
  flex-wrap: wrap;
}
.is-bg{
      width: 100%;
    height: 100%;
    text-align: center;
}
.banner {
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.bg-box {
  width: 100%;
   min-width: 1050px;
    box-sizing: border-box;
  display: flex;
  margin: 0 15%;
  .right-text {
    max-width: 964px;
    min-width: 600px;
    text-align: left;
    margin: 0 0 100px 50px;
    .title1 {
      margin: 0px 0 4px 0;
      font-size: $font-size-lv1;
      color: $font-color-main;
    }
    .title2 {
      margin: 0 0 35px 0;
      font-size: $font-size-lv5;
      color: $font-color-gary1;
    }
    span {
      font-size: $font-size-lv3;
      color: $font-color-gary1;
      line-height: 36px;
    }
    .list-bg{
      margin-bottom: 20px;
      display: block;
      max-width: 900px;
      min-width: 600px;
    }
  }
}
.news-box {
  max-width: 860px;
   min-width: 630px;
  display: flex;
  flex-wrap: nowrap;
  margin: 50px 30px 0px 30px;
  padding-bottom: 50px;
  border-bottom: 1px solid $font-color-gary2;
  cursor: pointer;
  img {
    width: 145px;
    height: 100px;
    margin: 0 20px;
  }
  span {
    display: flex;
  }
  .time {
    width: 41px;
    height: 51px;
    font-size: 16px;
    color: $font-color-main;
    font-weight: 600;
    span{
        color: $font-color-main;
        font-size: 30px;
        line-height: 20px;
    }
  }
  .red-line {
    display: inline-block;
    width: 16px;
    height: 6px;
    background-color: $red;
  }
  .text-box {
    max-width: 640px;
    min-width: 390px;
    p{
         font-size: $font-size-lv3;
          color: $font-color-black;
         line-height: 20px;
         margin-bottom: 20px;
    }
    span {
       max-width: 640px;
       min-width: 410px;
        color: $font-color-gary1;
        font-size: $font-size-lv5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
         line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue